import ProductShadowBase from "../productShadowBase";
import TravelEntry from "./Entry";

export default class TravelEntryElement extends ProductShadowBase {
  connectedCallback() {
    this.loadAndRender(() => (
      <TravelEntry
        backendHost={this.backendHost ?? undefined}
        appPathPrefix={this.appPathPrefix ?? undefined}
        skipCart={this.skipCart}
        channel={this.channel ?? undefined}
        language={this.language ?? undefined}
      />
    ));
  }
}
